module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-cagliari.svg?a5a560bf0d402b9f27b78a7bec2a4138";